<script>
export default {
  name: 'WelcomePanel',
}
</script>
<template>
  <section class="card welcome-panel">
    <div class="welcome-subtitle">
      {{ $gettext('Welcome to') }}
    </div>
    <div class="welcome-title">
      Traffic
    </div>
    <p class="welcome-text">
      {{ $gettext('Click on the button or link in the left bar to go to the map.') }}
    </p>
    <img
      class="welcome-icon"
      src="@static/transim_icon.jpg"
    >
  </section>
</template>
<style lang="scss" scoped>
.welcome-panel {
  max-width: 40%;
  overflow: auto;
}
.welcome-title {
  margin-bottom: 1rem;
  width: 80%
}
.welcome-text {
  font-size: 1.2rem;
  position: relative;
  z-index: 2;
  margin-bottom: 1rem;
}
.welcome-icon {
  position: absolute;
  width: 40%;
  z-index: 1;
  opacity: 0.6;
  right: 2rem;
  bottom: 2rem;
}

@media (width <= 1400px), (height <= 850px) {
  .welcome-title {
    font-size: 3rem !important;
  }
  .welcome-subtitle {
    font-size: 1.6rem;
  }
}
</style>
